<template>
  <div
    class="intestation-hero"
    v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'"
  >
    <p class="intestation-hero__pre">{{ pre }}</p>
    <h1 class="intestation-hero__title">{{ title }}</h1>
    <h2 :class="['intestation-hero__subtitle', { spaced: !text }]">
      {{ subtitle }}
    </h2>
    <!-- <p class="intestation-hero__text" v-if="text">{{ text }}</p> -->
    <div class="intestation-hero__download" v-if="!!download">
      <p class="intestation-hero__download__label">
        {{ download.label }}
      </p>
      <ButtonPrimary
        class="intestation-hero__download__button"
        :label="download.button"
        :iconAfter="downloadIcon"
        :url="baseUrl + download.url"
        :componentTitle="title"
        componentType="home hero"
      />
    </div>
    <ButtonScroll v-if="!noScroll" />
  </div>
  <div class="intestation-hero" v-else>
    <div class="top">
      <h1 class="intestation-hero__title">{{ title }}</h1>
      <h2 class="intestation-hero__subtitle">{{ subtitle }}</h2>
      <!-- <p class="intestation-hero__text">{{ text }}</p> -->
    </div>
    <div class="bottom">
      <ButtonScroll />
      <div class="intestation-hero__download" v-if="!!download">
        <p class="intestation-hero__download__label">
          {{ download.label }}
        </p>
        <ButtonPrimary
          class="intestation-hero__download__button"
          :label="download.button"
          :iconAfter="downloadIcon"
          :url="download.url"
          :componentTitle="title"
          componentType="home hero"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import ButtonPrimary from "../atoms/ButtonPrimary.vue";
import ButtonScroll from "../atoms/ButtonScroll.vue";
import { download as downloadIcon } from "@/assets/icons/icons.js";
import { inject } from "vue";

defineProps({
  pre: String,
  title: String,
  subtitle: String,
  text: String,
  download: Object,
  noScroll: { type: Boolean, default: false },
});

const $tvaMq = inject("$tvaMq");
const baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.intestation-hero {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .top {
    text-align: start;
    display: flex;
    flex-direction: column;
    height: 60%;
    padding-top: toRem(48);
  }
  .bottom {
    height: 40%;
    display: flex;
  }

  &__pre {
    color: var(--color-white);
    @include overlay-l;
    margin-bottom: toRem(28);
  }

  &__title {
    color: var(--color-white);
    @include header-h-1;
    line-height: normal;
    letter-spacing: -0.427px;
    margin-bottom: toRem(5);
    white-space: balance;
  }

  &__subtitle {
    color: var(--color-text-weaker);
    @include p-s;
    margin-bottom: 25vh;
    max-width: 370px;

    &.spaced {
      margin-bottom: toRem(204);
    }
  }

  &__text {
    color: var(--white-disabled);
    @include overlay-m;
    margin-bottom: toRem(118);
  }

  &__download {
    margin-bottom: toRem(50);

    &__label {
      color: var(--color-text-weaker);
      margin-bottom: toRem(12);
      @include dida-s;
    }
  }

  .tablet &,
  .mobile & {
    width: 100%;
    padding: 0 calc(var(--page-padding-h) + var(--page-padding-h-offset));
    .intestation-hero__title {
      margin-bottom: toRem(5);
      margin-top: auto;
      @include header-h-1;
    }
    .intestation-hero__subtitle {
      margin-bottom: toRem(28);
      @include p-s;
      max-width: none;
    }
    .intestation-hero__text {
      margin-bottom: toRem(69);
      @include overlay-m;
    }
    .intestation-hero__download {
      margin-bottom: 0;
      margin-left: auto;
      text-align: start;
    }
  }

  .mobile & {
    .top {
      padding-top: calc(var(--navbar-height) + toRem(45));
      height: 100%;
    }
    .bottom {
      height: 0%;
      display: none;
    }

    .intestation-hero__title {
      margin-bottom: toRem(5);
      margin-top: 0;
    }
    .intestation-hero__subtitle {
      margin-bottom: 0;
    }
  }

  .mobile & {
    height: fit-content;
  }
}
</style>
